import { graphql } from 'src/graphql';

import { MessagesFields } from 'src/fragments/messagesFields.fragment';

export const MessagesSubscription = graphql(
  `
    subscription messagesSubscription($filter: MessageSearchInput!) {
      messagesSubscription(filter: $filter) {
        ...MessagesFields
      }
    }
  `,
  [MessagesFields],
);
